import {
  KEY_CALL_ACCEPTED,
  KEY_CALL_TICKET,
  KEY_CALL_USED_TICKETS,
} from "../models";
import { ICallQualityOptions } from "../models/IMedia";
import { StorageService } from "./storage.service";
import { Restorable } from "@auvious/integrations";

class CallServiceCtrl extends Restorable {
  private _callQuality: ICallQualityOptions;

  constructor() {
    super([KEY_CALL_ACCEPTED, KEY_CALL_USED_TICKETS, KEY_CALL_TICKET]);
  }

  public setUsedTicket(ticket: string): void {
    StorageService.setUsedTicket(KEY_CALL_USED_TICKETS, ticket);
  }

  public clearUsedTickets(): void {
    StorageService.clearUsedTickets(KEY_CALL_USED_TICKETS);
  }

  public isTicketUsed(ticket: string): boolean {
    return StorageService.isTicketUsed(KEY_CALL_USED_TICKETS, ticket);
  }

  public setTicket(ticket: string): void {
    StorageService.setItem(KEY_CALL_TICKET, ticket, "session");
  }

  public clearTicket() {
    StorageService.removeItem(KEY_CALL_TICKET, "session");
  }

  public getStoredTicket() {
    return StorageService.getItem(KEY_CALL_TICKET, "session");
  }

  public setQualityOptions(quality: ICallQualityOptions) {
    this._callQuality = quality;
  }

  public getCallQualityOptions(): ICallQualityOptions {
    return this._callQuality;
  }
}

export const CallService = new CallServiceCtrl();
